import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]


export default /*@__PURE__*/_defineComponent({
  __name: 'SalaryExplanationLink',
  props: {
    label: {},
    url: {},
    large: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.url && __props.label)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: _normalizeClass(["salary-explanation-link", {'salary-explanation-link--large': __props.large}]),
        href: __props.url,
        target: "_blank",
        rel: "noopener noreferrer"
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("span", {
          class: "icon icon--info",
          "aria-hidden": "true"
        }, null, -1 /* CACHED */)),
        _createElementVNode("span", null, _toDisplayString(__props.label), 1 /* TEXT */)
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}
}

})